import { Box, Input } from "@chakra-ui/react";
import { CustomCellEditorProps } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";

import "ag-grid-community/styles/ag-grid.css"; // React Grid Logic
import "ag-grid-community/styles/ag-theme-quartz.css"; // Core CSS

export type TextCellEditorProps = CustomCellEditorProps & {
  onNoteUpdate?: (encounterId: string, note: string, immediate?: boolean) => void;
};

export const TextCellEditor = ({
  value,
  onValueChange,
  eventKey,
  stopEditing,
  data,
  onNoteUpdate,
}: TextCellEditorProps) => {
  const refInput = useRef<HTMLInputElement>(null);
  const [currentValue, setCurrentValue] = useState<string>(value || "");

  const updateValue = (val: string) => {
    const newValue = val === "" ? null : val;
    setCurrentValue(val);
    onValueChange(newValue);

    if (onNoteUpdate && data?.id) {
      onNoteUpdate(data.id, val || "");
    }
  };

  useEffect(() => {
    let startValue;

    if (eventKey === "Backspace") {
      startValue = "";
    } else if (eventKey && eventKey.length === 1) {
      startValue = eventKey;
    } else {
      startValue = value;
    }
    if (startValue == null) {
      startValue = "";
    }

    setCurrentValue(startValue);
    // Only update if there's an actual change from the original value
    if (startValue !== value) {
      updateValue(startValue);
    }
    refInput.current?.focus();
  }, []);

  // Handle Enter key to stop editing
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      stopEditing();
    }
  };

  return (
    <Box outline="none" borderRadius="0px">
      <Input
        value={currentValue}
        bg="transparent"
        border="none"
        outline="none"
        focusBorderColor="transparent"
        textDecoration="none"
        spellCheck={false}
        _focus={{
          textDecoration: "underline",
          textDecorationColor: "gray.300",
          textDecorationThickness: "2px",
          textUnderlineOffset: "2px",
        }}
        ref={refInput}
        onChange={event => updateValue(event.target.value)}
        onBlur={() => stopEditing()}
        onKeyDown={handleKeyDown}
        size="sm"
        p={0}
        width="100%"
      />
    </Box>
  );
};

export default TextCellEditor;
